import { createContext } from "react";

/**
 * How form controls present themselves — an axis orthogonal to the design
 * theme.
 *
 *  - `boxed` — dense, bordered fields with smaller text. The default,
 *    used by the high-density admin / dashboard screens.
 *  - `underlined` — spacious, underline-only fields with a large bold value.
 *    Opted into by the low-density customer flows (quote / booking checkout,
 *    login / sign up) that want the bold Cargo look.
 *
 * This axis only affects control density. Opt a form / panel / flow
 * into the underline look with `ControlPresentationProvider`; controls read it
 * with `useControlPresentation()`.
 */
export type ControlPresentation = "boxed" | "underlined";

export const ControlPresentationContext = createContext<
  ControlPresentation | undefined
>(undefined);
